import $ from "jquery";

const subsiteClass = $(".bt-subsite");

if (subsiteClass.length) {
  const colour = subsiteClass.data("colour");

  $("head").append(
    `<style>.bt-subsite:before{ background: ${colour} }</style>`
  );

  $("head").append(`
    <style>.nav--main-item.active:after,
    .nav--main-item.current:after,
    .nav--main-item.section:after,
    .nav--main-item:focus:after,
    .nav--main-item:hover:after{ background-color: ${colour} }</style>`);

  const secondary = subsiteClass.data("secondary");

  if (secondary.length) {
    $("head").append(
      `<style>.nav--main-item.active:after{ background: ${secondary} }</style>`
    );
  }
}

// To fix issue with Chrome/Windows :after pseudo-element
if (navigator.appVersion.indexOf("Win") !== -1) {
  $("head").append(`
    <style>
    .landing-nav-title,
    a.landing-arrow:after { top: 3px !important }
    </style>
  `);
}

const btn = $(".btn--subsite");

if (btn.length) {
  const colour = subsiteClass.data("colour");
  btn.css("background-color", colour);

  btn.hover(
    // eslint-disable-next-line
    function() {
      const $this = $(this);
      // eslint-disable-next-line
      $this.css("background-color", LightenDarkenColor(colour, 90));
    },
    // eslint-disable-next-line
    function() {
      const $this = $(this);
      $this.css("background-color", colour);
    }
  );
}

/**
 * @return {string}
 */
/* eslint-disable */
function LightenDarkenColor(col, amt) {
  const num = parseInt(col, 16);

  let r = (num >> 16) + amt;

  if (r > 255) {
    r = 255;
  } else if (r < 0) {
    r = 0;
  }

  let b = ((num >> 8) & 0x00ff) + amt;

  if (b > 255) {
    b = 255;
  } else if (b < 0) {
    b = 0;
  }

  let g = (num & 0x0000ff) + amt;

  if (g > 255) {
    g = 255;
  } else if (g < 0) {
    g = 0;
  }

  let colorCode = (g | (b << 8) | (r << 16)).toString(16);

  if (colorCode.length === 5) {
    colorCode = `${colorCode}0`;
  }

  return `#${colorCode}`;
}
/* eslint-enable */
